import { getOperationAST } from 'graphql';
import type { DocumentNode } from 'graphql';

// Given a gql file it returns the operation name
export const getQueryName = (gqlFile: DocumentNode) =>
  getOperationAST(gqlFile).name.value;
